<div class="user-groups-toolbar">
  <div class="user-groups-search" *ngIf="!disabled" style="font-size: 12px;">
    <mat-form-field appearance="outline" style="margin-bottom: 0;">
      <mat-label>{{ 'Contacts.Management.Groups.Search' | translate : locale.language }}</mat-label>
      <input matInput [formControl]="searchControl">
    </mat-form-field>
  </div>
  <div *ngIf="!disabled" class="user-groups-classification">
    <small>
      <mat-button-toggle-group name="classification" [formControl]="classification">
        <mat-button-toggle value="All">
          {{ 'Contacts.Management.Groups.All' | translate : locale.language }}
        </mat-button-toggle>
        <mat-button-toggle value="Internal">
          {{ 'Contacts.Management.Groups.Internal' | translate : locale.language }}
        </mat-button-toggle>
        <mat-button-toggle value="Public">
          {{ 'Contacts.Management.Groups.Public' | translate : locale.language }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </small>
  </div>
</div>




<div class="container">
  <app-loading [hasLoaded]="!isLoading" [hasFailed]="hasLoadError && !isLoading" [isCircle]="false"
    (retryClicked)="retryPreviousRequest()"></app-loading>

  <ng-container *ngIf="!hasLoadError">
    <div class="groups-container">
      <div class="flex-col available-groups-container" [ngStyle]="{width: showSelectedGroups ? '50%': '100%'}">
        <p>
          <strong>{{ 'Contacts.Management.Groups.Available' | translate : locale.language }}</strong>
        </p>

        <span *ngIf="!topLevelGroups[classification.value]?.length">
          {{ 'Contacts.Management.Groups.NoAvailableGroups' | translate : locale.language }}
        </span>
        <ng-container *ngFor="let parentGroup of topLevelGroups[classification.value]">
          <ng-container *ngTemplateOutlet="groupTemplate; context: { $implicit: parentGroup }"></ng-container>
        </ng-container>
      </div>

      <ng-content select="selectedGroups">

      </ng-content>
      <div class="flex-col available-groups-container" *ngIf="showSelectedGroups">
        <p>
          <strong>{{ 'Contacts.Management.Groups.Selected' | translate : locale.language }}</strong>
        </p>

        <div style="overflow-x: clip;">
          <mat-chip-set class="selected-groups-chip-list">
            <mat-chip disabled *ngIf="!selectedGroupNodes?.length">
              {{ 'Contacts.Management.Groups.NoGroupsSelected' | translate : locale.language }}
            </mat-chip>
            <ng-container *ngFor="let node of selectedGroupNodes">
              <mat-chip [removable]="!disabled" (removed)="onToggleGroup(node, false)">
                {{ node.group.name }}
                <button *ngIf="!disabled" matChipRemove [attr.aria-label]="'Remove ' + node.group.name" [tabIndex]="0">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip>
            </ng-container>
          </mat-chip-set>
        </div>
      </div>

    </div>
  </ng-container>
</div>

<ng-template #groupTemplate let-node>
  <div class="flex-row">
    <div class="flex-col">
      <div class="flex-row" style="align-items: center">
        <mat-icon *ngIf="hasChildren(node.group) && !canAssignToParentGroups"
          style="color: #757575; margin-left: 0.2rem; margin-right: 0.2rem;">folder</mat-icon>
        <mat-checkbox [indeterminate]="isIndeterminate(node)" [disabled]="isNodeDisabled(node)" *ngIf="!hasChildren(node.group) || canAssignToParentGroups"
          [checked]="isGroupSelected(node.group) || isParentGroupSelected(node.group)" (change)="onToggleGroup(node, $event.checked)" [aria-labelledby]="node.group.id + '-label'">
        </mat-checkbox>
        <button [id]="node.group.id + '-label'" [disabled]="isNodeDisabled(node)" mat-button
          color="primary" (click)="onToggleGroup(node, undefined)" style="justify-content: left;">
          {{ node.group.name }}
        </button>
        <button mat-icon-button (click)="onExpandNode(node)" *ngIf="hasChildren(node.group)" [attr.aria-label]="(node.expanded ? 'Collapse ' : 'Expand ') + node.group.name">
          <mat-icon>{{ node.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
        <mat-progress-bar mode="indeterminate" *ngIf="node.loading" style="width: 50px"></mat-progress-bar>
        <mat-icon *ngIf="node.group.isLink" style="color: #757575">link</mat-icon>
      </div>
      <ng-container *ngIf="node.expanded">
        <div class="flex-row" *ngFor="let child of getChildren(node)"
          [style.margin-left]="getIndentLevel(child)">
          <ng-container *ngTemplateOutlet="groupTemplate; context: { $implicit: child }"></ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>